'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _navigationActions = require('../../../../reducers/navigationActions');

var _FullScreenErrorModal = require('../../../modal/FullScreenErrorModal');

var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);

var _ModalActionsList = require('../../../modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        currentUser: state.getIn(['app', 'currentUser'])
    };
};

// Actions
// Lib


var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        navigateToLogin: function navigateToLogin(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToLogin)());
        }
    };
};

var BoardAccessDeniedModal = function BoardAccessDeniedModal(props) {
    var currentUser = props.currentUser,
        close = props.close;


    var isGuest = currentUser.get('isGuest');

    var guestActions = [{ text: 'Log in', func: props.navigateToLogin }];
    var loggedInActions = [{ text: 'Log in as someone else', func: props.navigateToLogin }];
    var actions = isGuest ? guestActions : loggedInActions;

    var loggedInMessage = isGuest ? null : _react2.default.createElement(
        'p',
        { className: 'details secondary' },
        'You\'re currently logged in as:',
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'strong',
            null,
            currentUser.get('email')
        )
    );

    return _react2.default.createElement(
        _FullScreenErrorModal2.default,
        { overlay: true, close: close },
        _react2.default.createElement(
            'h2',
            null,
            'You don\'t have permission to view this board'
        ),
        _react2.default.createElement(_ModalActionsList2.default, { actions: actions }),
        loggedInMessage
    );
};

BoardAccessDeniedModal.propTypes = {
    requestAccess: _propTypes2.default.func,
    navigateToLogin: _propTypes2.default.func,
    currentUser: _propTypes2.default.object,
    close: _propTypes2.default.func
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

exports.default = enhance(BoardAccessDeniedModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/components/BoardAccessDeniedModal.js
// module id = 1764
// module chunks = 0